import { IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";

import { SubActivityApi, SubActivityGridDto, SubActivitySearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { SearchTablePage } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IActivitySubActivitiesPageProps {
  activityId: number;
}

export const ActivitySubActivitiesPage: React.FunctionComponent<IActivitySubActivitiesPageProps> = ({ activityId }) => {
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();
  const api = useApiService(SubActivityApi);
  useHistory();
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (row: SubActivityGridDto) => (
          <Link target="_blank" to={`${ERoutes.subActivity}/${row.subActivityId}/detail/view`}>
            {row.name}
          </Link>
        ),
      },
    ],
    [t]
  );

  const search = React.useCallback(
    (sObj) =>
      api.baseSearch(
        SubActivitySearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, activityId: activityId })
      ),
    [activityId, api, currentLanguage.languageId]
  );

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={() => api.getSearchCriterias(true)}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(
          SubActivitySearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, activityId: activityId })
        )
      }
      sortKeys={{ name: "ASC" }}
      withCard={false}
    />
  );
};
